import React, { useRef, useState } from 'react'
import { FaPlus } from 'react-icons/fa6'
import AnimatedText11 from './AnimatedText11'
import iconorange from '../images/icon_orange.svg';

const FaqsSection = () => {
    const answerRef = useRef([]);
    const faqsData = [
        {
            question: "Why is a landing page essential for my business?",
            answer: "A landing page is essential for your business because it drives conversions by focusing on specific goals like capturing leads or promoting products. It enhances marketing effectiveness with clear information and strong calls to action. This optimization improves ROI and helps grow your customer base."
        },
        {
            question: "What is the cost for a landing page?",
            answer: "The cost for a Shopify or Replo landing page varies based on complexity and customization required. cost can fluctuate depending on specific needs and additional functionalities."
        },
        {
            question: "How do you stand out from other agencies?",
            answer: "We stand out from other agencies by aligning with your time zone and consistently delivering high-quality work ahead of schedule. Even if you don't use Figma, our CRO expertise allows us to create beautiful, high-converting landing pages tailored to your website's needs. Our focus on exceptional design and strategic optimization ensures your project's success and maximizes your ROI."
        },
        {
            question: "Who are your usual clients?",
            answer: "Our usual clients are a diverse mix of startups, small to medium-sized enterprises, and established businesses across various industries. They seek innovative and customized solutions to enhance their digital presence, improve user experience, and drive conversions. We work closely with e-commerce brands, tech companies, service providers, and creative agencies to achieve their unique goals and deliver measurable results."
        },
        {
            question: "Do you collaborate with new brands?",
            answer: "Yes, we collaborate with new brands, offering tailored solutions to help them establish a strong digital presence and achieve their business goals. Our team is dedicated to supporting startups with innovative strategies, expert guidance, and personalized service to ensure their success in a competitive market."
        },
        {
            question: "Who is Sudhanshu Batra?",
            answer: "Sudhanshu, founder of Design Landers, is a skilled Shopify Developer and Designer with over 8 years of experience. He works directly with clients, focusing on exceptional Conversion Rate Optimization (CRO) and Search Engine Optimization (SEO) for e-commerce brands."
        },
    ];

    const [openFaq, setOpenFaq] = useState(null);

    const toggleFaq = (index) => {
        if (openFaq === index) {
            setOpenFaq(null)
        }
        else {
            setOpenFaq(index)
        }
    };
  return (
    <div>
          <section id="faqs">
                <div className='container-xxl faqs-container'>
                    <div className='headingbox'>
                        <div className='text-box' data-aos="fade-up">
                            <img id="faqsimg" className='icon_orange' src={iconorange} alt='icon-orange' />
                            <p>Our Query</p>
                        </div>

                        <AnimatedText11 />
                    </div>
                   
                    <div className='row faqs-row'>
                        <div className='col-md-9 faqs-col'>
                            {faqsData.map((value, index) => (
                                <div className='box' key={index} onClick={() => toggleFaq(index)}>
                                    <div className='que'>
                                        <div className='txt'>
                                            <p>{value.question}</p>
                                        </div>
                                       


                                        <div className="icon">
                                            <FaPlus
                                                className={`faqs-icon ${openFaq === index ? "open" : ""
                                                    }`}
                                            />
                                        </div>


                                    </div>
                                    <div
                                        ref={(el) => (answerRef.current[index] = el)}
                                        className={`ans ${openFaq === index ? 'active' : ''}`}
                                        style={{
                                            maxHeight: openFaq === index ? `${answerRef.current[index]?.scrollHeight}px` : '0px',
                                        }}
                                    >
                                        <span>{value.answer}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </section>
    </div>
  )
}

export default FaqsSection